import { atom } from "jotai";

export type PlusPopupState = {
  fromDrawerUrl?: string;
  isShowArticlePopup: boolean;
  isShowDetailListingPopup: boolean;
  originalUrl?: string;
};

export const plusPopupAtom = atom<PlusPopupState>({
  isShowArticlePopup: false,
  isShowDetailListingPopup: false,
});
